import NextImage from 'next/image';

import placeholder from '../../../../public/images/placeholder-image.png';
import { getTextExcerpt } from '../../../helpers/string';
import type { Image as CardImage } from '../../PostsViewer/types/Image';
import { Text } from '../../Text/Text';

export interface GearItemCardProps {
  brand: string;
  image: CardImage | null;
  name: string;
}

const BRAND_TEXT_LIMIT = 68;
const DEFAULT_CARD_IMAGE_SIZE = { height: 200, width: 480 };

export const GearItemCard = ({ brand, image, name }: GearItemCardProps) => {
  const imageSrc = image?.url;
  const imageHeight = image?.height ?? DEFAULT_CARD_IMAGE_SIZE.height;
  const imageWidth = image?.width ?? DEFAULT_CARD_IMAGE_SIZE.width;

  return (
    <div className="bg-lake-fog mb-2 h-[90px] w-full rounded-md px-3 py-2 sm:px-4 sm:py-1">
      <div className="flex items-stretch">
        <NextImage
          alt={`${brand} ${name}`}
          className="mr-3 size-[64px] object-contain mix-blend-multiply sm:size-[80px]"
          height={imageHeight}
          src={imageSrc || placeholder}
          width={imageWidth}
        />
        <div className="h-inherit flex flex-col justify-center">
          <Text variant="sm" className="text-midnight mb-0" title={brand}>
            {getTextExcerpt(brand, BRAND_TEXT_LIMIT)}
          </Text>
          <Text
            variant="sm"
            className="text-trench mb-0 line-clamp-2 font-semibold text-ellipsis"
            title={name}
          >
            {name}
          </Text>
        </div>
      </div>
    </div>
  );
};
